import React from 'react';
import { useUser } from '../contexts/UserContext';
import './WaterProgressBar.css';

interface WaterProgressBarProps {
    currentMl: number;
    goalMl: number;
    units?: 'ml' | 'oz';
}

export const WaterProgressBar: React.FC<WaterProgressBarProps> = ({ currentMl, goalMl, units = 'ml' }) => {
    const { profile } = useUser();
    // Prefer passed unit, fallback to profile, finally default to 'ml'
    const displayUnit = units || profile?.settings?.units?.water || 'ml';

    const displayCurrent = displayUnit === 'oz' ? Math.round(currentMl / 29.5735) : Math.round(currentMl);
    const displayGoal = displayUnit === 'oz' ? Math.round(goalMl / 29.5735) : Math.round(goalMl);

    const percentage = Math.min(100, Math.max(0, (currentMl / goalMl) * 100));

    return (
        <div className="water-progress-bar-container">
            <div className="water-stats-header">
                <span className="water-label">💧 Hydration</span>
                <span className="water-values">{displayCurrent} / {displayGoal} {displayUnit}</span>
            </div>
            <div className="progress-track">
                <div
                    className="progress-fill"
                    style={{ width: `${percentage}%` }}
                />
            </div>
        </div>
    );
};
